import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  insight_zone_logo: require("../../../assets/wc/images/insight_zone_white.png"),
  right_arrow: require("../../../assets/svg/arrow-right.svg"),
  of_logo: require("../../../assets/wc/images/of_logo.svg"),
  background_1920: require("../../../assets/of/videos/background_1920x1080_v2.webm"),
};

export default assets;
